// extracted by mini-css-extract-plugin
export default {"container":"hor_26QHx","inner":"hor_inn__2aQr","thumbnail":"hor_thu_3ofnX","responsive":"hor_res_1XZjo","label":"hor_lab_sp7R3"};